<template>
  <div class="app-container">
    <PurchaseViewForm is-edit />
  </div>
</template>
<script>
import PurchaseViewForm from '@/views/center-business/purchase/components/PurchaseViewForm.vue';
export default {
  name: 'BusinessPurchaseApplyIndexEdit',
  components: { PurchaseViewForm },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {},
};
</script>
